// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

import {createProps, createSplitProps} from "@qualcomm-ui/utils/object"

import type {SideNavApiProps} from "./side-nav.types.js"

export const sideNavProps: (keyof SideNavApiProps)[] =
  createProps<SideNavApiProps>()(
    "defaultOpen",
    "dir",
    "disabled",
    "getRootNode",
    "onOpenChange",
    "open",
  )

export const splitSideNavProps: <Props extends SideNavApiProps>(
  props: Props,
) => [SideNavApiProps, Omit<Props, keyof SideNavApiProps>] =
  createSplitProps<SideNavApiProps>(sideNavProps)
